export function appInitializerNoop() {
  return function() {};
}
